import NoUserFound from "./NoUserFound";
import NoUserFoundWithoutCommercePlatform from "./NoUserFound";

export { NoUserFound, NoUserFoundWithoutCommercePlatform };

export default NoUserFound;
